import Icon from "~/assets/icons/Icon";
import { Text } from "~/components/Text";

function MultipleCarts({ cartAmount }: { cartAmount: number }) {
  return (
    <div className="p-4 rounded-md border border-secondary-200 mb-20">
      <div className="flex items-center gap-3 md:gap-5 mb-3">
        <Icon
          name="moreCarts"
          className="text-primary w-7 h-7 md:w-10 md:h-10"
        />
        <Text className="md:text-2xl">
          Vær opmærksom på at du har flere kurve
        </Text>
      </div>
      <Text className="text-2xs md:text-xs text-neutral-500">
        Du har valgt varer fra {cartAmount} forskellige butikker. Vi kan
        desværre ikke klare betalingen for alle varerne på én gang - så lad os
        tage en kurv af gangen.
      </Text>
    </div>
  );
}

export default MultipleCarts;
